import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Select } from 'antd';

@inject('commonStore')
@observer
class CenterOptionList extends Component {

  UNSAFE_componentWillMount() {
    // 지사 셀렉트박스 리스트
    this.props.commonStore.disBranchOption();
  }

  render() {
    const {
      branchOption,
      branchOptionOrder,
      disCenterOption,
      centerOption,
      
      sessionLoginInfo,
    } = this.props.commonStore;
    const {
      onlyBranchCd, branchCdDisabled,
      ceBranchCdValue, ceCdValue, eBranchCdChange, ceCdfuncChange 
    } = this.props;

    // 정렬순서에 있는 지사 옵션
    const centerOptionOrder = () => { return(
      branchOptionOrder.map((itemOrder)=>{ return(
        branchOption.map((item)=>{
          return(
            (itemOrder.ceCd === item.ceCd) &&
            <Select.Option key={item.ceCd}>{item.ceNm}</Select.Option>
          )
        }))
      })
    )};
    
    // 정렬순서에 없는 지사 옵션
    const centerOptionOrderOut = () => { return(
      branchOption.map((item)=>{
        let orderOut = false; // 정렬 순서 배열에 있는지 여부 ( 지사 셀렉트 박스 )
        branchOptionOrder.map((itemOrder)=>{ return(
          // ▼ 지사 셀렉트 박스 조건
          (itemOrder.ceCd === item.ceCd) && (orderOut = true)
        )})
        return(
          (orderOut === false) &&
          <Select.Option key={item.ceCd}>{item.ceNm}</Select.Option>
        )
      })
    )};
    return (
      // ▼ 셀렉트박스 로지텍은 사용여부만 나오게 하게 체크함 -> 0614 수정 : 로지텍도 지사 셀렉트박스 뜨도록 수정
      (sessionLoginInfo !== null && sessionLoginInfo.cGbn !== undefined &&  sessionLoginInfo.cGbn !== null) && 
      (
      // 지사 셀렉트박스만 사용할지 여부 
      (onlyBranchCd !== undefined && onlyBranchCd !== null && onlyBranchCd === true)
        ? 
        // 6.26 수정 : 로지텍만 센터관리 넓이 넓히기
        (sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG)
        ?
          <Fragment>
            <Select 
              disabled={branchCdDisabled}
              style={{ width: 230, marginRight: '20px' }}
              value={ceBranchCdValue}
              onChange={(value)=>{
                (eBranchCdChange !== undefined && eBranchCdChange !== null)
                && eBranchCdChange(value);
              }}
            >
              <Select.Option key={""}>선택해주세요.</Select.Option>
              {centerOptionOrder()}
              {centerOptionOrderOut()}
            </Select>
          </Fragment>
        :
        <Fragment>
            <Select 
              disabled={branchCdDisabled}
              style={{ width: 150, marginRight: '20px' }}
              value={ceBranchCdValue}
              onChange={(value)=>{
                (eBranchCdChange !== undefined && eBranchCdChange !== null)
                && eBranchCdChange(value);
              }}
            >
              <Select.Option key={""}>선택해주세요.</Select.Option>
              {centerOptionOrder()}
              {centerOptionOrderOut()}
            </Select>
          </Fragment>


        : 
          // 6.26 수정 : 로지텍만 센터관리 넓이 넓히기
          (sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG)
          ?
            <Fragment>
              <span className="mo_srch">
                <span className="labal2">지사</span>
                <Select
                  style={{ width: 230, marginRight: '20px' }}
                  value={ceBranchCdValue}
                  onChange={(value)=>{
                    disCenterOption(value);
                    (eBranchCdChange !== undefined && eBranchCdChange !== null)
                    && eBranchCdChange(value);
                  }}
                >
                  <Select.Option key={""}>전체</Select.Option>
                  {centerOptionOrder()}
                  {centerOptionOrderOut()}
                </Select>
              </span>
              <span className="mo_srch">
                <span className="labal2">센터</span>
                <Select
                  disabled={ceBranchCdValue==='' ? true : false}
                  style={{ width: 150, marginRight: '20px' }}
                  value={ceCdValue}
                  onChange={(value)=>{
                    (ceCdfuncChange !== undefined && ceCdfuncChange !== null)
                    && ceCdfuncChange(value);
                  }}
                >
                  <Select.Option key={""}>전체</Select.Option>
                  {centerOption.map(item=>{
                    return(
                    <Select.Option key={item.ceCd}>{item.ceNm}</Select.Option>
                    )
                  })}
                </Select>
              </span>
            </Fragment>
            :
            <Fragment>
              <span className="mo_srch">
                <span className="labal2">지사</span>
                <Select
                  style={{ width: 150, marginRight: '20px' }}
                  value={ceBranchCdValue}
                  onChange={(value)=>{
                    disCenterOption(value);
                    (eBranchCdChange !== undefined && eBranchCdChange !== null)
                    && eBranchCdChange(value);
                  }}
                >
                  <Select.Option key={""}>전체</Select.Option>
                  {centerOptionOrder()}
                  {centerOptionOrderOut()}
                </Select>
              </span>
              <span className="mo_srch">
                <span className="labal2">센터</span>
                <Select
                  disabled={ceBranchCdValue==='' ? true : false}
                  style={{ width: 150, marginRight: '20px' }}
                  value={ceCdValue}
                  onChange={(value)=>{
                    (ceCdfuncChange !== undefined && ceCdfuncChange !== null)
                    && ceCdfuncChange(value);
                  }}
                >
                  <Select.Option key={""}>전체</Select.Option>
                  {centerOption.map(item=>{
                    return(
                    <Select.Option key={item.ceCd}>{item.ceNm}</Select.Option>
                    )
                  })}
                </Select>
              </span>
            </Fragment>
    ));
  }

}

export default CenterOptionList;
